/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MultiVehicleGroupAssignmentCreate
 */
export interface MultiVehicleGroupAssignmentCreate {
    /**
     * 
     * @type {Array<string>}
     * @memberof MultiVehicleGroupAssignmentCreate
     */
    vehicleGroupIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MultiVehicleGroupAssignmentCreate
     */
    vehicleIds: Array<string>;
}

/**
 * Check if a given object implements the MultiVehicleGroupAssignmentCreate interface.
 */
export function instanceOfMultiVehicleGroupAssignmentCreate(value: object): value is MultiVehicleGroupAssignmentCreate {
    if (!('vehicleGroupIds' in value) || value['vehicleGroupIds'] === undefined) return false;
    if (!('vehicleIds' in value) || value['vehicleIds'] === undefined) return false;
    return true;
}

export function MultiVehicleGroupAssignmentCreateFromJSON(json: any): MultiVehicleGroupAssignmentCreate {
    return MultiVehicleGroupAssignmentCreateFromJSONTyped(json, false);
}

export function MultiVehicleGroupAssignmentCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MultiVehicleGroupAssignmentCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'vehicleGroupIds': json['vehicleGroupIds'],
        'vehicleIds': json['vehicleIds'],
    };
}

export function MultiVehicleGroupAssignmentCreateToJSON(json: any): MultiVehicleGroupAssignmentCreate {
    return MultiVehicleGroupAssignmentCreateToJSONTyped(json, false);
}

export function MultiVehicleGroupAssignmentCreateToJSONTyped(value?: MultiVehicleGroupAssignmentCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vehicleGroupIds': value['vehicleGroupIds'],
        'vehicleIds': value['vehicleIds'],
    };
}

